(function () {
    "use strict";

    angular
        .module("app")
        .component("connectQboButton", {
            bindings: {
                redirectto: "@?",
            },
            templateUrl: ['version', function (version) {
                return `/js/components/connectQboButton/connect-qbo-button.html?v=${version}`
            }],
            transclude: true,
            controller: ConnectQboButtonController,
            controllerAs: "vm"
        });

    ConnectQboButtonController.$inject = ["$rootScope", "request"];

    function ConnectQboButtonController($rootScope, request) {
        var vm = this;

        vm.$onInit = onInit;
        vm.authorizeQbo = authorizeQbo;
        vm.redirectto = vm.redirectto || location.hash.substring(2)

        vm.notificationDuration = 0
        vm.notificationType = ''
        vm.notificationMessage = ''
        vm.notificationOnClose = () => {
          vm.notificationMessage = ''
        }

        function showNotification(duration, type, message) {
            vm.notificationDuration = duration
            vm.notificationType = type
            vm.notificationMessage = message
            vm.notificationNonce = Math.random()
        }

        function onInit() {
        }

        function authorizeQbo() {
            request.get($rootScope.apiEndpoint + "/quickbooks/authorize").then(function (response) {
                const qboUrl = response.data.redirectTo
                window.open(qboUrl, "_self")
            }, function (e) {
                console.log(e);
                showNotification(5, 'Error', 'There was an error connecting to QuickBooks')
            });
        }
    }
})();
